import type { ApiScopeRequirement } from '@ipfabric/utils';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import { selectMeetsApiScope } from 'utils/rbac/selectMeetsApiScope';

type ApiScopeRequirementMetHook = (requirement: ApiScopeRequirement) => boolean;

/**
 * @example
 * const apiScopeRequirementMet = useApiScopeRequirementMet();
 * if (
 *   !apiScopeRequirementMet({ method: 'POST', path: '/os/restart-service' })
 * ) {
 *   return null;
 * }
 */
export const useApiScopeRequirementMet = (): ApiScopeRequirementMetHook => {
  return useGlobalStateContextSelectors({
    meetsApiScope: selectMeetsApiScope,
  }).meetsApiScope;
};
